import { apiClient, ApiResponse } from './api';

export interface ReferralStats {
  referralCode: string;
  referredBy: string | null;
  accountAge: number;
  totalReferred: number;
  completedReferrals: number;
  pendingReferrals: number;
  bonusAtsQuick: number;
  bonusAtsFull: number;
  bonusCvGeneration: number;
  maxBonusAtsQuick: number;
  maxBonusAtsFull: number;
  maxBonusCvGeneration: number;
}

export const referralService = {
  async getStats(): Promise<ReferralStats> {
    const response = await apiClient.get<ApiResponse<ReferralStats>>('/api/v1/referral/me');
    return response.data.data;
  },

  async applyCode(code: string): Promise<{ applied: boolean }> {
    const response = await apiClient.post<ApiResponse<{ applied: boolean }>>('/api/v1/referral/apply', { code });
    return response.data.data;
  },
};
